// Auto-generated file that is updated by a script.
// *DO NOT EDIT*
// Edits will be lost on update.

// spell-checker: disable
export type ISODateTimeString = `${number}-${number}-${number}T${number}:${number}:${number}.${number}Z`;

export interface KnownTracker {
	domains: string | string[];
	organizationKnownAs?: string;
	trackerKnownAs?: string;
	ghosteryId?: string;
	ghosteryOrganizationName?: string;
	whenAddedToGhostery?: ISODateTimeString;
	disconnectMeName?: string;
	whenAddedToDisconnectMe?: ISODateTimeString;
}

export interface KnownTrackersArchive {
	trackers: KnownTracker[];
}

export const KnownTrackersArchive: KnownTrackersArchive = {
	"trackers": [
		{
			"domains": "tiktok.com",
			"organizationKnownAs": "TikTok (ByteDance Inc)",
			"disconnectMeName": "TikTok",
			"whenAddedToDisconnectMe": "2022-09-16T17:00:39.000Z",
			"ghosteryId": "5432",
			"ghosteryOrganizationName": "ByteDance Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bluekai.com",
			"disconnectMeName": "Oracle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Oracle"
		},
		{
			"domains": "33across.com",
			"disconnectMeName": "33Across",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "375",
			"ghosteryOrganizationName": "33Across",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "33Across"
		},
		{
			"domains": "3lift.com",
			"disconnectMeName": "TripleLift",
			"whenAddedToDisconnectMe": "2017-03-09T23:35:41.000Z",
			"ghosteryId": "2609",
			"ghosteryOrganizationName": "TripleLift, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "TripleLift"
		},
		{
			"domains": "ad-delivery.net",
			"disconnectMeName": "AdDelivery",
			"whenAddedToDisconnectMe": "2023-10-06T03:07:40.000Z",
			"organizationKnownAs": "AdDelivery",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "admanmedia.com",
			"disconnectMeName": "AdmanMedia",
			"whenAddedToDisconnectMe": "2022-12-27T19:21:26.000Z",
			"ghosteryId": "4490",
			"ghosteryOrganizationName": "illumin",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adnxs.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "adsrvr.org",
			"disconnectMeName": "The Trade Desk",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "The Trade Desk"
		},
		{
			"domains": "agkn.com",
			"disconnectMeName": "TransUnion",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3452",
			"ghosteryOrganizationName": "TransUnion",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "TransUnion"
		},
		{
			"domains": "amazon-adsystem.com",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Amazon"
		},
		{
			"domains": "bidr.io",
			"disconnectMeName": "Comcast",
			"whenAddedToDisconnectMe": "2019-04-29T22:43:38.000Z",
			"ghosteryId": "4160",
			"ghosteryOrganizationName": "Beeswax",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "btloader.com",
			"disconnectMeName": "Blockthrough",
			"whenAddedToDisconnectMe": "2023-07-24T14:03:04.000Z",
			"ghosteryId": "2675",
			"ghosteryOrganizationName": "Blockthrough",
			"whenAddedToGhostery": "2024-01-23T11:41:01.000Z",
			"organizationKnownAs": "Blockthrough"
		},
		{
			"domains": "casalemedia.com",
			"disconnectMeName": "IndexExchange",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "crwdcntrl.net",
			"disconnectMeName": "Lotame",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "103",
			"ghosteryOrganizationName": "Lotame",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Lotame"
		},
		{
			"domains": "doubleclick.net",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "eqads.com",
			"disconnectMeName": "EQ Ads",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "853",
			"ghosteryOrganizationName": "EQ Works",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "everesttech.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "facebook.com",
			"disconnectMeName": "Meta",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Meta"
		},
		{
			"domains": "facebook.net",
			"disconnectMeName": "Meta",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Meta"
		},
		{
			"domains": "fastclick.net",
			"disconnectMeName": "PublicisGroupe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "google.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "googleadservices.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "googlesyndication.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "googletagservices.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"organizationKnownAs": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "id5-sync.com",
			"disconnectMeName": "ID5",
			"whenAddedToDisconnectMe": "2019-11-26T18:35:32.000Z",
			"organizationKnownAs": "ID5",
			"whenAddedToGhostery": "2023-07-28T09:11:50.000Z"
		},
		{
			"domains": "intentiq.com",
			"disconnectMeName": "IntentIQ",
			"whenAddedToDisconnectMe": "2023-07-24T14:03:04.000Z",
			"ghosteryId": "12",
			"ghosteryOrganizationName": "AlmondNet",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ipredictive.com",
			"disconnectMeName": "Viant",
			"whenAddedToDisconnectMe": "2018-08-27T19:07:15.000Z",
			"ghosteryId": "3878",
			"ghosteryOrganizationName": "Viant",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Viant"
		},
		{
			"domains": "liadm.com",
			"disconnectMeName": "LiveIntent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "674",
			"ghosteryOrganizationName": "LiveIntent",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LiveIntent"
		},
		{
			"domains": "lijit.com",
			"disconnectMeName": "Sovrn",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "99",
			"ghosteryOrganizationName": "Sovrn Holdings Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Sovrn"
		},
		{
			"domains": "linkedin.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "mediago.io",
			"disconnectMeName": "Baidu",
			"whenAddedToDisconnectMe": "2023-06-26T19:29:11.000Z",
			"organizationKnownAs": "Baidu"
		},
		{
			"domains": "ntv.io",
			"disconnectMeName": "Nativo",
			"whenAddedToDisconnectMe": "2022-12-27T19:21:26.000Z",
			"ghosteryId": "2568",
			"ghosteryOrganizationName": "Nativo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Nativo"
		},
		{
			"domains": "onetag-sys.com",
			"disconnectMeName": "OneTag",
			"whenAddedToDisconnectMe": "2023-06-15T20:47:42.000Z",
			"organizationKnownAs": "OneTag"
		},
		{
			"domains": "openx.net",
			"disconnectMeName": "OpenX",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "OpenX"
		},
		{
			"domains": "pippio.com",
			"disconnectMeName": "LiveRamp",
			"whenAddedToDisconnectMe": "2018-08-27T19:07:15.000Z",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LiveRamp"
		},
		{
			"domains": "postrelease.com",
			"disconnectMeName": "Nativo",
			"whenAddedToDisconnectMe": "2016-12-05T22:54:12.000Z",
			"ghosteryId": "2568",
			"ghosteryOrganizationName": "Nativo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Nativo"
		},
		{
			"domains": "primis.tech",
			"disconnectMeName": "Primis",
			"whenAddedToDisconnectMe": "2019-05-19T18:14:45.000Z",
			"organizationKnownAs": "Primis"
		},
		{
			"domains": "pubmatic.com",
			"disconnectMeName": "PubMatic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "348",
			"ghosteryOrganizationName": "PubMatic, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "PubMatic"
		},
		{
			"domains": "rlcdn.com",
			"disconnectMeName": "LiveRamp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LiveRamp"
		},
		{
			"domains": "rubiconproject.com",
			"disconnectMeName": "Magnite",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sharethrough.com",
			"disconnectMeName": "Sharethrough",
			"whenAddedToDisconnectMe": "2018-08-27T19:07:15.000Z",
			"ghosteryId": "718",
			"ghosteryOrganizationName": "Sharethrough, Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Sharethrough"
		},
		{
			"domains": "simpli.fi",
			"disconnectMeName": "Simpli.fi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "550",
			"ghosteryOrganizationName": "Simplifi Holdings Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "smaato.net",
			"disconnectMeName": "VerveGroup",
			"whenAddedToDisconnectMe": "2022-12-27T19:21:26.000Z",
			"ghosteryId": "920",
			"ghosteryOrganizationName": "Verve Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "smartadserver.com",
			"disconnectMeName": "Equativ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "stackadapt.com",
			"disconnectMeName": "StackAdapt",
			"whenAddedToDisconnectMe": "2018-08-27T19:07:15.000Z",
			"ghosteryId": "3952",
			"ghosteryOrganizationName": "StackAdapt",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "StackAdapt"
		},
		{
			"domains": "stripe.com",
			"disconnectMeName": "Stripe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"organizationKnownAs": "Stripe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "stripe.network",
			"disconnectMeName": "Stripe",
			"whenAddedToDisconnectMe": "2018-12-08T05:06:08.000Z",
			"organizationKnownAs": "Stripe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tapad.com",
			"disconnectMeName": "Tapad",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "937",
			"ghosteryOrganizationName": "Telenor Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "technoratimedia.com",
			"disconnectMeName": "Synacor",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1650",
			"ghosteryOrganizationName": "Synacor",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Synacor"
		},
		{
			"domains": "yahoo.com",
			"disconnectMeName": "Yahoo!",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "yieldmo.com",
			"disconnectMeName": "Yieldmo",
			"whenAddedToDisconnectMe": "2016-12-05T22:54:12.000Z",
			"ghosteryId": "2918",
			"ghosteryOrganizationName": "Yieldmo, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Yieldmo"
		},
		{
			"domains": "youtube.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "zemanta.com",
			"disconnectMeName": "Outbrain",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "189",
			"ghosteryOrganizationName": "Outbrain",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Outbrain"
		},
		{
			"domains": "adobedc.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2023-12-05T19:38:40.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2024-09-25T14:34:57.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "adobedtm.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe",
			"whenAddedToDisconnectMe": "2017-02-22T11:43:37.000Z"
		},
		{
			"domains": "appboycdn.com",
			"disconnectMeName": "Braze",
			"whenAddedToDisconnectMe": "2024-01-23T00:07:37.000Z",
			"ghosteryId": "5321",
			"ghosteryOrganizationName": "Braze",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Braze"
		},
		{
			"domains": "braze.com",
			"disconnectMeName": "Braze",
			"whenAddedToDisconnectMe": "2024-01-23T00:07:37.000Z",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cloudfront.net",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Amazon"
		},
		{
			"domains": "contentsquare.net",
			"disconnectMeName": "ContentSquare",
			"whenAddedToDisconnectMe": "2023-04-13T17:07:02.000Z",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cookielaw.org",
			"disconnectMeName": "OneTrust",
			"whenAddedToDisconnectMe": "2024-08-01T18:03:23.000Z",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "OneTrust"
		},
		{
			"domains": "go-mpulse.net",
			"disconnectMeName": "Akamai",
			"whenAddedToDisconnectMe": "2016-12-05T22:54:12.000Z",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Akamai"
		},
		{
			"domains": "googletagmanager.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"whenAddedToDisconnectMe": "2017-08-07T07:07:07.000Z"
		},
		{
			"domains": "licdn.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "omtrdc.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "onetrust.com",
			"disconnectMeName": "OneTrust",
			"whenAddedToDisconnectMe": "2023-12-22T17:55:26.000Z",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "OneTrust"
		},
		{
			"domains": "onetrust.io",
			"disconnectMeName": "OneTrust",
			"whenAddedToDisconnectMe": "2024-01-23T00:07:37.000Z"
		},
		{
			"domains": "quantummetric.com",
			"disconnectMeName": "QuantumMetric",
			"whenAddedToDisconnectMe": "2023-11-06T21:08:04.000Z",
			"ghosteryId": "4748",
			"ghosteryOrganizationName": "Quantum Metric, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "usabilla.com",
			"disconnectMeName": "STG",
			"whenAddedToDisconnectMe": "2024-01-23T00:07:37.000Z",
			"ghosteryId": "2858",
			"ghosteryOrganizationName": "SurveyMonkey",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adxcel-ec2.com",
			"disconnectMeName": "ArtsAI",
			"whenAddedToDisconnectMe": "2024-01-23T00:07:37.000Z"
		},
		{
			"domains": "akstat.io",
			"disconnectMeName": "Akamai",
			"whenAddedToDisconnectMe": "2023-10-24T22:47:21.000Z",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Akamai"
		},
		{
			"domains": "bazaarvoice.com",
			"disconnectMeName": "Bazaarvoice",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1272",
			"ghosteryOrganizationName": "Bazaarvoice",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Bazaarvoice"
		},
		{
			"domains": "bidswitch.net",
			"disconnectMeName": "Criteo",
			"whenAddedToDisconnectMe": "2016-02-15T07:41:21.000Z",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Criteo"
		},
		{
			"domains": "bing.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "ctnsnet.com",
			"disconnectMeName": "Crimtan",
			"whenAddedToDisconnectMe": "2023-10-06T03:07:40.000Z",
			"ghosteryId": "606",
			"ghosteryOrganizationName": "Crimtan",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Crimtan"
		},
		{
			"domains": "demdex.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "google-analytics.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "googleapis.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "gstatic.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "pinimg.com",
			"disconnectMeName": "Pinterest",
			"whenAddedToDisconnectMe": "2018-08-27T19:07:15.000Z",
			"ghosteryId": "1306",
			"ghosteryOrganizationName": "Pinterest",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Pinterest"
		},
		{
			"domains": "pinterest.com",
			"disconnectMeName": "Pinterest",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1306",
			"ghosteryOrganizationName": "Pinterest",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Pinterest"
		},
		{
			"domains": "sc-static.net",
			"disconnectMeName": "Snap",
			"whenAddedToDisconnectMe": "2023-09-06T18:35:49.000Z",
			"ghosteryId": "157",
			"ghosteryOrganizationName": "Snap Technologies",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Snap"
		},
		{
			"domains": "snapchat.com",
			"disconnectMeName": "Snap",
			"whenAddedToDisconnectMe": "2022-09-16T17:00:39.000Z",
			"ghosteryId": "157",
			"ghosteryOrganizationName": "Snap Technologies",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Snap"
		},
		{
			"domains": "sojern.com",
			"disconnectMeName": "Sojern",
			"whenAddedToDisconnectMe": "2019-04-24T21:24:57.000Z",
			"ghosteryId": "782",
			"ghosteryOrganizationName": "Sojern, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Sojern"
		},
		{
			"domains": "tacdn.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tamgrt.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tribalfusion.com",
			"disconnectMeName": "VDX",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "64",
			"ghosteryOrganizationName": "Exponential Interactive, Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "yieldoptimizer.com",
			"disconnectMeName": "Adara Media",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "286",
			"ghosteryOrganizationName": "Adara",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adara"
		},
		{
			"domains": "yimg.com",
			"disconnectMeName": "Yahoo!",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "optimizely.com",
			"disconnectMeName": "Optimizely",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Optimizely"
		},
		{
			"domains": "adroll.com",
			"disconnectMeName": "NextRoll",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "412",
			"ghosteryOrganizationName": "AdRoll",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "demandbase.com",
			"disconnectMeName": "Demandbase",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "53",
			"ghosteryOrganizationName": "Demandbase",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Demandbase"
		},
		{
			"domains": "yimg.jp",
			"disconnectMeName": "LYCorp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2456",
			"ghosteryOrganizationName": "Yahoo! Japan",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "salesloft.com",
			"disconnectMeName": "Salesloft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "6sc.co",
			"disconnectMeName": "6sense",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2536",
			"ghosteryOrganizationName": "6Sense",
			"whenAddedToGhostery": "2024-09-30T14:49:21.000Z",
			"organizationKnownAs": "6Sense"
		},
		{
			"domains": "impactcdn.com",
			"disconnectMeName": "Impact",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tvsquared.com",
			"disconnectMeName": "Innovid",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "episerver.net",
			"disconnectMeName": "Optimizely",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2024-10-28T18:08:10.000Z",
			"organizationKnownAs": "Optimizely"
		},
		{
			"domains": "amplitude.com",
			"disconnectMeName": "Amplitude",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3070",
			"ghosteryOrganizationName": "Amplitude",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Amplitude"
		},
		{
			"domains": "trkn.us",
			"disconnectMeName": "Claritas",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "company-target.com",
			"disconnectMeName": "Demandbase",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "53",
			"ghosteryOrganizationName": "Demandbase",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Demandbase"
		},
		{
			"domains": "ml314.com",
			"disconnectMeName": "Bombora",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "933",
			"ghosteryOrganizationName": "Bombora",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Bombora"
		},
		{
			"domains": "taboola.com",
			"disconnectMeName": "Taboola",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Taboola"
		},
		{
			"domains": "outbrain.com",
			"disconnectMeName": "Outbrain",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Outbrain"
		},
		{
			"domains": "reson8.com",
			"disconnectMeName": "Resonate",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "868",
			"ghosteryOrganizationName": "Resonate",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Resonate"
		},
		{
			"domains": "zoominfo.com",
			"disconnectMeName": "ZoomInfo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "datadoghq-browser-agent.com",
			"disconnectMeName": "DataDog",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "sentry.io",
			"disconnectMeName": "FunctionalSoftware",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "scorecardresearch.com",
			"disconnectMeName": "comScore",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "246",
			"ghosteryOrganizationName": "comScore, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "comScore"
		},
		{
			"domains": "px-cloud.net",
			"disconnectMeName": "HumanSecurity",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "redditstatic.com",
			"disconnectMeName": "reddit",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "reddit"
		},
		{
			"domains": "teads.tv",
			"disconnectMeName": "Teads",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2521",
			"ghosteryOrganizationName": "Teads",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Teads"
		},
		{
			"domains": "ispot.tv",
			"disconnectMeName": "iSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tk0x1.com",
			"disconnectMeName": "LoopMe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "reddit.com",
			"disconnectMeName": "reddit",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "reddit"
		},
		{
			"domains": "clarity.ms",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "quantserve.com",
			"disconnectMeName": "Quantcast",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Quantcast"
		},
		{
			"domains": "statcounter.com",
			"disconnectMeName": "StatCounter",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "162",
			"ghosteryOrganizationName": "StatCounter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "StatCounter"
		},
		{
			"domains": "e-planning.net",
			"disconnectMeName": "Caraytech",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "509",
			"ghosteryOrganizationName": "e-planning",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "minutemedia-prebid.com",
			"disconnectMeName": "MinuteMedia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "quantcount.com",
			"disconnectMeName": "Quantcast",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Quantcast"
		},
		{
			"domains": "openxcdn.net",
			"disconnectMeName": "OpenX",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "eu-1-id5-sync.com",
			"disconnectMeName": "ID5",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "adtrafficquality.google",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2024-10-28T18:23:01.000Z"
		},
		{
			"domains": "media-amazon.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "criteo.com",
			"disconnectMeName": "Criteo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Criteo"
		},
		{
			"domains": "ytimg.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cloudflareinsights.com",
			"disconnectMeName": "Cloudflare",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2913",
			"ghosteryOrganizationName": "Cloudflare",
			"whenAddedToGhostery": "2023-08-31T15:44:33.000Z",
			"organizationKnownAs": "Cloudflare"
		},
		{
			"domains": "dwin1.com",
			"disconnectMeName": "Awin",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1202",
			"ghosteryOrganizationName": "Axel Springer Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ads-twitter.com",
			"disconnectMeName": "Twitter",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "moengage.com",
			"disconnectMeName": "MoEngage",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "t.co",
			"disconnectMeName": "Twitter",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "twitter.com",
			"disconnectMeName": "Twitter",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "oath.com",
			"disconnectMeName": "Yahoo!",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "clean.gg",
			"disconnectMeName": "HumanSecurity",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "media.net",
			"disconnectMeName": "media.net",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1879",
			"ghosteryOrganizationName": "Media.net",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Media.net"
		},
		{
			"domains": "seedtag.com",
			"disconnectMeName": "SeedTag",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5280",
			"ghosteryOrganizationName": "Seedtag Advertising S.L",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "SeedTag"
		},
		{
			"domains": "criteo.net",
			"disconnectMeName": "Criteo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Criteo"
		},
		{
			"domains": "indexww.com",
			"disconnectMeName": "IndexExchange",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bounceexchange.com",
			"disconnectMeName": "Wunderkind",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2468",
			"ghosteryOrganizationName": "Bounce Exchange",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "flashtalking.com",
			"disconnectMeName": "Flashtalking",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "442",
			"ghosteryOrganizationName": "Flashtalking",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Flashtalking"
		},
		{
			"domains": "kampyle.com",
			"disconnectMeName": "Medallia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Medallia"
		},
		{
			"domains": "pulseinsights.com",
			"ghosteryId": "3656",
			"ghosteryOrganizationName": "Pulse Insights",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mczbf.com",
			"disconnectMeName": "PublicisGroupe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "dotomi.com",
			"disconnectMeName": "PublicisGroupe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "videoamp.com",
			"disconnectMeName": "VideoAmp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cdnwidget.com",
			"disconnectMeName": "CDNWidget",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "bouncex.net",
			"disconnectMeName": "Wunderkind",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "eum-appdynamics.com",
			"ghosteryId": "2793",
			"ghosteryOrganizationName": "AppDynamics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cloudflare.com",
			"disconnectMeName": "Cloudflare",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2913",
			"ghosteryOrganizationName": "Cloudflare",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Cloudflare"
		},
		{
			"domains": "microsoft.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "akamaized.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "microsoftonline.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "atdmt.com",
			"disconnectMeName": "Meta",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Meta"
		},
		{
			"domains": "live.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "gfx.ms",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "azure.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "visualstudio.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "twimg.com",
			"disconnectMeName": "Twitter",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "x.com",
			"disconnectMeName": "Twitter",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "browser-intake-datadoghq.com",
			"disconnectMeName": "DataDog",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "btttag.com",
			"ghosteryId": "3355",
			"ghosteryOrganizationName": "Blue Triangle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "attn.tv",
			"disconnectMeName": "Attentive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "attentivemobile.com",
			"disconnectMeName": "AttentiveMobile",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pdst.fm",
			"disconnectMeName": "Spotify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mathtag.com",
			"disconnectMeName": "MediaMath",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "290",
			"ghosteryOrganizationName": "MediaMath, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "MediaMath"
		},
		{
			"domains": "azureedge.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "noibu.com",
			"disconnectMeName": "Noibu",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mountain.com",
			"disconnectMeName": "MNTN",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "wisepops.net",
			"disconnectMeName": "Wisepops",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "appspot.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wisepops.com",
			"ghosteryId": "3348",
			"ghosteryOrganizationName": "WisePops",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "turn.com",
			"disconnectMeName": "Nexxen",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5298",
			"ghosteryOrganizationName": "Singtel",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "techlab-cdn.com",
			"disconnectMeName": "Akamai",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "qualtrics.com",
			"disconnectMeName": "Qualtrics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Qualtrics"
		},
		{
			"domains": "trackjs.com",
			"ghosteryId": "3549",
			"ghosteryOrganizationName": "TrackJS",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adsafeprotected.com",
			"disconnectMeName": "Integral Ad Science",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "474",
			"ghosteryOrganizationName": "Integral Ad Science, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Integral Ad Science"
		},
		{
			"domains": "privacy-mgmt.com",
			"disconnectMeName": "Sourcepoint",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5230",
			"ghosteryOrganizationName": "Sourcepoint",
			"whenAddedToGhostery": "2024-04-25T15:06:02.000Z",
			"organizationKnownAs": "Sourcepoint"
		},
		{
			"domains": "newrelic.com",
			"disconnectMeName": "New Relic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "942",
			"ghosteryOrganizationName": "New Relic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "New Relic"
		},
		{
			"domains": "privacymanager.io",
			"disconnectMeName": "LiveRamp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "adlightning.com",
			"disconnectMeName": "Boltive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5304",
			"ghosteryOrganizationName": "Ad Lightning",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cxense.com",
			"disconnectMeName": "Piano",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1160",
			"ghosteryOrganizationName": "Cxense",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tiqcdn.com",
			"ghosteryId": "662",
			"ghosteryOrganizationName": "Tealium",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "doubleverify.com",
			"disconnectMeName": "DoubleVerify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "58",
			"ghosteryOrganizationName": "DoubleVerify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "DoubleVerify"
		},
		{
			"domains": "celtra.com",
			"ghosteryId": "921",
			"ghosteryOrganizationName": "Celtra",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "2mdn.net",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "the-ozone-project.com",
			"disconnectMeName": "OzoneProject",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "newscgp.com",
			"disconnectMeName": "NCAudienceExchange",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5365",
			"ghosteryOrganizationName": "News Corp",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "imrworldwide.com",
			"disconnectMeName": "Nielsen",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Nielsen"
		},
		{
			"domains": "dianomi.com",
			"disconnectMeName": "dianomi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1284",
			"ghosteryOrganizationName": "Dianomi",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Dianomi"
		},
		{
			"domains": "brandmetrics.com",
			"disconnectMeName": "BrandMetrics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "datadome.co",
			"disconnectMeName": "Datadome",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5226",
			"ghosteryOrganizationName": "DataDome",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "DataDome"
		},
		{
			"domains": "360yield.com",
			"disconnectMeName": "Improve Digital",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "523",
			"ghosteryOrganizationName": "Improve Digital",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Improve Digital"
		},
		{
			"domains": "parsely.com",
			"disconnectMeName": "Parse.ly",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1009",
			"ghosteryOrganizationName": "Parse.ly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Parse.ly"
		},
		{
			"domains": "kargo.com",
			"disconnectMeName": "Kargo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Kargo"
		},
		{
			"domains": "permutive.app",
			"disconnectMeName": "Permutive",
			"organizationKnownAs": "Permutive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "nr-data.net",
			"disconnectMeName": "New Relic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "942",
			"ghosteryOrganizationName": "New Relic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "New Relic"
		},
		{
			"domains": "permutive.com",
			"disconnectMeName": "Permutive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5148",
			"ghosteryOrganizationName": "Permutive, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Permutive"
		},
		{
			"domains": "typekit.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "connatix.com",
			"disconnectMeName": "Connatix.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3942",
			"ghosteryOrganizationName": "Connatix Native Exchange Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "crazyegg.com",
			"disconnectMeName": "Crazy Egg",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "50",
			"ghosteryOrganizationName": "Crazy Egg",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Crazy Egg"
		},
		{
			"domains": "serverbid.com",
			"disconnectMeName": "Consumable",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5347",
			"ghosteryOrganizationName": "GiftConnect",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cootlogix.com",
			"disconnectMeName": "Cootlogix",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "uidapi.com",
			"disconnectMeName": "The Trade Desk",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "hadronid.net",
			"disconnectMeName": "Audigent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ad.gt",
			"disconnectMeName": "Audigent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "richaudience.com",
			"disconnectMeName": "RichAudience",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "semasio.net",
			"disconnectMeName": "Fyllo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2088",
			"ghosteryOrganizationName": "Semasio GmbH",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sonobi.com",
			"disconnectMeName": "Sonobi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1412",
			"ghosteryOrganizationName": "Sonobi, Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Sonobi"
		},
		{
			"domains": "emxdgt.com",
			"disconnectMeName": "Cadent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5333",
			"ghosteryOrganizationName": "Engine",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "yellowblue.io",
			"disconnectMeName": "Unity",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "kueezrtb.com",
			"disconnectMeName": "Kueez",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "sitescout.com",
			"disconnectMeName": "BasisTechnologies",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "714",
			"ghosteryOrganizationName": "Centro",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "1rx.io",
			"disconnectMeName": "Nexxen",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "673",
			"ghosteryOrganizationName": "RhythmOne, LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "streamrail.com",
			"ghosteryId": "5016",
			"ghosteryOrganizationName": "ironSource",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "brealtime.com",
			"disconnectMeName": "Cadent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "trustarc.com",
			"disconnectMeName": "TrustARC",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "775",
			"ghosteryOrganizationName": "TrustArc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "TrustArc"
		},
		{
			"domains": "w55c.net",
			"disconnectMeName": "Roku",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "292",
			"ghosteryOrganizationName": "DataXu",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "amazon.dev",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "coveo.com",
			"disconnectMeName": "Coveo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "bizographics.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "clicktale.net",
			"disconnectMeName": "ContentSquare",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "41",
			"ghosteryOrganizationName": "ClickTale",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "driftt.com",
			"disconnectMeName": "Drift",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "marketo.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mktoresp.com",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "hs-scripts.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hotjar.com",
			"disconnectMeName": "Hotjar",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3632",
			"ghosteryOrganizationName": "Hotjar",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Hotjar"
		},
		{
			"domains": "heapanalytics.com",
			"disconnectMeName": "Heap",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2695",
			"ghosteryOrganizationName": "Heap",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Heap"
		},
		{
			"domains": "hs-banner.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2024-03-22T13:47:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hsleadflows.net",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hubspot.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hsadspixel.net",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2024-06-06T09:29:25.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hs-analytics.net",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hotjar.io",
			"disconnectMeName": "Hotjar",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3632",
			"ghosteryOrganizationName": "Hotjar",
			"whenAddedToGhostery": "2024-02-26T13:50:19.000Z",
			"organizationKnownAs": "Hotjar"
		},
		{
			"domains": "hsforms.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2024-06-06T08:37:37.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hubapi.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "wp.com",
			"disconnectMeName": "Automattic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "245",
			"ghosteryOrganizationName": "Automattic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Automattic"
		},
		{
			"domains": "googleoptimize.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "evgnet.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "evergage.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "atlassian.net",
			"ghosteryId": "5312",
			"ghosteryOrganizationName": "Atlassian",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "serving-sys.com",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Amazon"
		},
		{
			"domains": "osano.com",
			"disconnectMeName": "Osano",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "confiant-integrations.net",
			"disconnectMeName": "Confiant",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "creativecdn.com",
			"disconnectMeName": "RTBHouse",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3371",
			"ghosteryOrganizationName": "RTB House",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "clarium.io",
			"disconnectMeName": "Confiant",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "deliverimp.com",
			"disconnectMeName": "DeliverImp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "rtbhouse.com",
			"disconnectMeName": "RTBHouse",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "branch.io",
			"disconnectMeName": "Branch",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4164",
			"ghosteryOrganizationName": "Branch Metrics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Branch"
		},
		{
			"domains": "force.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ipify.org",
			"disconnectMeName": "ipify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "app.link",
			"disconnectMeName": "Branch",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4164",
			"ghosteryOrganizationName": "Branch Metrics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Branch"
		},
		{
			"domains": "contextweb.com",
			"disconnectMeName": "PulsePoint",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "293",
			"ghosteryOrganizationName": "PulsePoint, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "PulsePoint"
		},
		{
			"domains": "truste.com",
			"disconnectMeName": "TrustARC",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "775",
			"ghosteryOrganizationName": "TrustArc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "TrustArc"
		},
		{
			"domains": "thrtle.com",
			"disconnectMeName": "Throtle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "betrad.com",
			"disconnectMeName": "Crownpeak",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4957",
			"ghosteryOrganizationName": "Crownpeak",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Crownpeak"
		},
		{
			"domains": "evidon.com",
			"ghosteryId": "4957",
			"ghosteryOrganizationName": "Crownpeak",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "w-x.co",
			"ghosteryId": "263",
			"ghosteryOrganizationName": "IBM",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "appsflyer.com",
			"disconnectMeName": "AppsFlyer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4300",
			"ghosteryOrganizationName": "AppsFlyer",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "AppsFlyer"
		},
		{
			"domains": "medallia.com",
			"disconnectMeName": "Medallia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Medallia"
		},
		{
			"domains": "siteimproveanalytics.com",
			"disconnectMeName": "SiteImprove",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Siteimprove"
		},
		{
			"domains": "clearbitjs.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "en25.com",
			"disconnectMeName": "Oracle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Oracle"
		},
		{
			"domains": "soundcloud.com",
			"ghosteryId": "1817",
			"ghosteryOrganizationName": "SoundCloud",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "siteimproveanalytics.io",
			"disconnectMeName": "SiteImprove",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove",
			"whenAddedToGhostery": "2024-09-23T10:10:00.000Z",
			"organizationKnownAs": "Siteimprove"
		},
		{
			"domains": "fullstory.com",
			"disconnectMeName": "Fullstory",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4100",
			"ghosteryOrganizationName": "fullstory",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "fullstory"
		},
		{
			"domains": "adnxs-simple.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2024-03-22T13:47:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "siftscience.com",
			"disconnectMeName": "SiftScience",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2686",
			"ghosteryOrganizationName": "Sift Science",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adswizz.com",
			"disconnectMeName": "SiriusXM",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adgrx.com",
			"disconnectMeName": "Samsung",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "433",
			"ghosteryOrganizationName": "Samsung",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Samsung"
		},
		{
			"domains": "signifyd.com",
			"disconnectMeName": "Signifyd",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4889",
			"ghosteryOrganizationName": "Signifyd",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Signifyd"
		},
		{
			"domains": "riskified.com",
			"disconnectMeName": "Riskified",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5292",
			"ghosteryOrganizationName": "Riskified",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Riskified"
		},
		{
			"domains": "impactradius-event.com",
			"disconnectMeName": "Impact",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2230",
			"ghosteryOrganizationName": "Impact Radius",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Impact"
		},
		{
			"domains": "forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "hexagon-analytics.com",
			"ghosteryId": "5421",
			"ghosteryOrganizationName": "Brandwatch",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "applovin.com",
			"disconnectMeName": "Applovin",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "online-metrix.net",
			"disconnectMeName": "OnlineMetrix",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "chartbeat.com",
			"disconnectMeName": "Chartbeat",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "313",
			"ghosteryOrganizationName": "ChartBeat",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "ChartBeat"
		},
		{
			"domains": "chartbeat.net",
			"disconnectMeName": "Chartbeat",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "313",
			"ghosteryOrganizationName": "ChartBeat",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "ChartBeat"
		},
		{
			"domains": "3gl.net",
			"ghosteryId": "2897",
			"ghosteryOrganizationName": "Catchpoint Systems",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "acsbapp.com",
			"disconnectMeName": "Accessibe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "dynatrace.com",
			"disconnectMeName": "Dynatrace",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "micpn.com",
			"disconnectMeName": "MoveableInk",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "expedia.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tagcommander.com",
			"ghosteryId": "1789",
			"ghosteryOrganizationName": "Commanders Act",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "trvl-px.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "rkdms.com",
			"disconnectMeName": "Merkle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sail-horizon.com",
			"disconnectMeName": "SailThru",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1550",
			"ghosteryOrganizationName": "Sailthru",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Sailthru"
		},
		{
			"domains": "tru.am",
			"disconnectMeName": "TrueAnthem",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3030",
			"ghosteryOrganizationName": "trueAnthem",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "trueAnthem"
		},
		{
			"domains": "bluecava.com",
			"disconnectMeName": "Adstra",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "670",
			"ghosteryOrganizationName": "Qualia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sail-personalize.com",
			"disconnectMeName": "SailThru",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1550",
			"ghosteryOrganizationName": "Sailthru",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Sailthru"
		},
		{
			"domains": "innovid.com",
			"disconnectMeName": "Innovid",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "825",
			"ghosteryOrganizationName": "Innovid",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Innovid"
		},
		{
			"domains": "xg4ken.com",
			"disconnectMeName": "Skai",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1299",
			"ghosteryOrganizationName": "Kenshoo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "invocacdn.com",
			"disconnectMeName": "Invoca",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "securedvisit.com",
			"disconnectMeName": "Merkle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2234",
			"ghosteryOrganizationName": "SecuredVisit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "rtmark.net",
			"disconnectMeName": "Propeller Ads",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5316",
			"ghosteryOrganizationName": "Big Wall Vision",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "admedo.com",
			"disconnectMeName": "Admedo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3222",
			"ghosteryOrganizationName": "Admedo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Admedo"
		},
		{
			"domains": "mrf.io",
			"disconnectMeName": "Marfeel",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "newsroom.bi",
			"disconnectMeName": "Marfeel",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "hscollectedforms.net",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2024-06-06T08:37:37.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "bttrack.com",
			"disconnectMeName": "Bidtellect",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4166",
			"ghosteryOrganizationName": "Simpli.fi",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "undertone.com",
			"disconnectMeName": "Undertone",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "269",
			"ghosteryOrganizationName": "Perion",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pushnami.com",
			"disconnectMeName": "Pushnami",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "jquery.com",
			"ghosteryId": "5354",
			"ghosteryOrganizationName": "JS Foundation",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "p7cloud.net",
			"disconnectMeName": "p7cloud.net",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "getblueshift.com",
			"disconnectMeName": "BlueShift",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "servenobid.com",
			"disconnectMeName": "ServeNoBid",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "a-mo.net",
			"disconnectMeName": "AdaptMX",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "omnitagjs.com",
			"disconnectMeName": "AdYouLike",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2629",
			"ghosteryOrganizationName": "Open Web",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "moatads.com",
			"disconnectMeName": "Oracle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Oracle"
		},
		{
			"domains": "insightexpressai.com",
			"disconnectMeName": "BainCapital",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "114",
			"ghosteryOrganizationName": "Kantar Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "blismedia.com",
			"disconnectMeName": "Blis",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5318",
			"ghosteryOrganizationName": "Blis",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Blis"
		},
		{
			"domains": "connextra.com",
			"disconnectMeName": "Betgenius",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "502",
			"ghosteryOrganizationName": "Connextra",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "hsforms.net",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2024-06-06T09:11:42.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "livechatinc.com",
			"disconnectMeName": "LiveChat",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2653",
			"ghosteryOrganizationName": "LiveChat",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LiveChat"
		},
		{
			"domains": "ubembed.com",
			"disconnectMeName": "Unbounce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pbbl.co",
			"disconnectMeName": "PebblePost",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "visualwebsiteoptimizer.com",
			"disconnectMeName": "Wingify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "276",
			"ghosteryOrganizationName": "Wingify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Wingify"
		},
		{
			"domains": "omappapi.com",
			"disconnectMeName": "Retyp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5129",
			"ghosteryOrganizationName": "OptinMonster",
			"whenAddedToGhostery": "2024-03-22T13:47:05.000Z"
		},
		{
			"domains": "aralego.com",
			"disconnectMeName": "ucfunnel",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "aralego.net",
			"ghosteryId": "5431",
			"ghosteryOrganizationName": "ucfunnel",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "appdynamics.com",
			"ghosteryId": "2793",
			"ghosteryOrganizationName": "AppDynamics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "c3tag.com",
			"disconnectMeName": "C3 Metrics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "754",
			"ghosteryOrganizationName": "C3 Metrics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "C3 Metrics"
		},
		{
			"domains": "iesnare.com",
			"disconnectMeName": "TransUnion",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "388",
			"ghosteryOrganizationName": "iovation",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "gannett-cdn.com",
			"ghosteryId": "76",
			"ghosteryOrganizationName": "Gannett Digital Media Network",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "polarcdn-terrax.com",
			"disconnectMeName": "Nova",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "polarcdn-pentos.com",
			"disconnectMeName": "Nova",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "urbanairship.com",
			"ghosteryId": "3072",
			"ghosteryOrganizationName": "Urban Airship, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "unrulymedia.com",
			"disconnectMeName": "Nexxen",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1904",
			"ghosteryOrganizationName": "Tremor International",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "inq.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "230",
			"ghosteryOrganizationName": "TouchCommerce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "blueconic.net",
			"disconnectMeName": "BlueConic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3860",
			"ghosteryOrganizationName": "BlueConic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "BlueConic"
		},
		{
			"domains": "tealiumiq.com",
			"disconnectMeName": "Tealium",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "662",
			"ghosteryOrganizationName": "Tealium",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Tealium"
		},
		{
			"domains": "nuance.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "akamaihd.net",
			"disconnectMeName": "Akamai",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Akamai"
		},
		{
			"domains": "lpsnmedia.net",
			"disconnectMeName": "LivePerson",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LivePerson"
		},
		{
			"domains": "liveperson.com",
			"disconnectMeName": "LivePerson",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LivePerson"
		},
		{
			"domains": "liveperson.net",
			"disconnectMeName": "LivePerson",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LivePerson"
		},
		{
			"domains": "sharethis.com",
			"disconnectMeName": "ShareThis",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "149",
			"ghosteryOrganizationName": "ShareThis, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "ShareThis"
		},
		{
			"domains": "fundraiseup.com",
			"disconnectMeName": "FundraiseUp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "fndrsp.net",
			"disconnectMeName": "FundraiseUp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "wknd.ai",
			"disconnectMeName": "Wunderkind",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "channeladvisor.com",
			"disconnectMeName": "ChannelAdvisor",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "367",
			"ghosteryOrganizationName": "ChannelAdvisor",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "ChannelAdvisor"
		},
		{
			"domains": "abtasty.com",
			"disconnectMeName": "ABTasty",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3037",
			"ghosteryOrganizationName": "AB Tasty",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "spotify.com",
			"ghosteryId": "1816",
			"ghosteryOrganizationName": "Spotify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "iperceptions.com",
			"disconnectMeName": "iPerceptions",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "92",
			"ghosteryOrganizationName": "iPerceptions",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "iPerceptions"
		},
		{
			"domains": "aspnetcdn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "twitchcdn.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "jtvnw.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ttvnw.net",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Amazon"
		},
		{
			"domains": "bigcrunch.com",
			"disconnectMeName": "BigCrunch",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "gumgum.com",
			"disconnectMeName": "GumGum",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "84",
			"ghosteryOrganizationName": "GumGum",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "GumGum"
		},
		{
			"domains": "js7k.com",
			"disconnectMeName": "Yahoo!",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "researchnow.com",
			"disconnectMeName": "Dynata",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2770",
			"ghosteryOrganizationName": "Research Now Group, Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "justpremium.com",
			"disconnectMeName": "GumGum",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2882",
			"ghosteryOrganizationName": "GumGum",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "GumGum"
		},
		{
			"domains": "wistia.com",
			"disconnectMeName": "Wistia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1307",
			"ghosteryOrganizationName": "Wistia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Wistia"
		},
		{
			"domains": "media6degrees.com",
			"disconnectMeName": "Dstillery",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "111",
			"ghosteryOrganizationName": "Dstillery",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Dstillery"
		},
		{
			"domains": "spotxchange.com",
			"disconnectMeName": "Magnite",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2991",
			"ghosteryOrganizationName": "RTL Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pages02.net",
			"ghosteryId": "263",
			"ghosteryOrganizationName": "IBM",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "eloqua.com",
			"disconnectMeName": "Oracle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Oracle"
		},
		{
			"domains": "sentry-cdn.com",
			"disconnectMeName": "FunctionalSoftware",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "clicktripz.com",
			"disconnectMeName": "ClickTripz",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3110",
			"ghosteryOrganizationName": "ClickTripz",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "ClickTripz"
		},
		{
			"domains": "mainadv.com",
			"ghosteryId": "1622",
			"ghosteryOrganizationName": "mainADV",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "smct.co",
			"ghosteryId": "4941",
			"ghosteryOrganizationName": "Smarter Click Technology",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "smct.io",
			"disconnectMeName": "intent.ly",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "udmserve.net",
			"disconnectMeName": "Underdog Media",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "748",
			"ghosteryOrganizationName": "Underdog Media LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Underdog Media"
		},
		{
			"domains": "adentifi.com",
			"disconnectMeName": "AdTheorent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3622",
			"ghosteryOrganizationName": "AdTheorent, Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "AdTheorent"
		},
		{
			"domains": "ninthdecimal.com",
			"disconnectMeName": "InMarket",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "youtube-nocookie.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "truoptik.com",
			"disconnectMeName": "TransUnion",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tynt.com",
			"disconnectMeName": "33Across",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "375",
			"ghosteryOrganizationName": "33Across",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "33Across"
		},
		{
			"domains": "tiktokv.us",
			"disconnectMeName": "TikTok",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "lytics.io",
			"ghosteryId": "4376",
			"ghosteryOrganizationName": "Lytics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "colossusssp.com",
			"disconnectMeName": "ColossusMedia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "monetate.net",
			"disconnectMeName": "Monetate",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "601",
			"ghosteryOrganizationName": "Monetate",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Monetate"
		},
		{
			"domains": "proper.io",
			"ghosteryId": "5216",
			"ghosteryOrganizationName": "Proper Media",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "anyclip.com",
			"disconnectMeName": "AnyClip",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "springserve.com",
			"disconnectMeName": "SpringServe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2581",
			"ghosteryOrganizationName": "SpringServe, LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "SpringServe"
		},
		{
			"domains": "euid.eu",
			"disconnectMeName": "EUiD",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "geoedge.be",
			"disconnectMeName": "Geoedge",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "disqus.com",
			"disconnectMeName": "Disqus",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "nextmillmedia.com",
			"disconnectMeName": "NextMillennium",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "smilewanted.com",
			"disconnectMeName": "SmileWanted",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "brainlyads.com",
			"disconnectMeName": "NextMillennium",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "storygize.net",
			"disconnectMeName": "Storygize",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tremorhub.com",
			"disconnectMeName": "Nexxen",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "564",
			"ghosteryOrganizationName": "Tremor Video",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adform.net",
			"disconnectMeName": "Adform",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "457",
			"ghosteryOrganizationName": "Adform",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adform"
		},
		{
			"domains": "ck-ie.com",
			"disconnectMeName": "SmartyAds",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "adkernel.com",
			"disconnectMeName": "AdKernel",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "spot.im",
			"disconnectMeName": "OpenWeb",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3625",
			"ghosteryOrganizationName": "Spot.IM Ltd.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "p-n.io",
			"disconnectMeName": "Pushly",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "childlikeform.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "skimresources.com",
			"disconnectMeName": "Taboola",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "587",
			"ghosteryOrganizationName": "SkimLinks",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "opecloud.com",
			"disconnectMeName": "TripleLift",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4582",
			"ghosteryOrganizationName": "1plusX AG",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "guim.co.uk",
			"ghosteryId": "5402",
			"ghosteryOrganizationName": "The Guardian",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "guardianapps.co.uk",
			"ghosteryId": "5402",
			"ghosteryOrganizationName": "The Guardian",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "unblockia.com",
			"disconnectMeName": "Unblockia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "opti-digital.com",
			"disconnectMeName": "optidigital",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "bugsnag.com",
			"disconnectMeName": "SmartBear",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3347",
			"ghosteryOrganizationName": "SmartBear",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "SmartBear"
		},
		{
			"domains": "speedcurve.com",
			"disconnectMeName": "SpeedCurve",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "scene7.com",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "vimeo.com",
			"disconnectMeName": "Vimeo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1552",
			"ghosteryOrganizationName": "Vimeo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Vimeo"
		},
		{
			"domains": "pardot.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Salesforce"
		},
		{
			"domains": "ipinfo.io",
			"disconnectMeName": "IDBLLC",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5074",
			"ghosteryOrganizationName": "ipinfo.io",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "px-cdn.net",
			"disconnectMeName": "HumanSecurity",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "onesignal.com",
			"disconnectMeName": "OneSignal",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4304",
			"ghosteryOrganizationName": "OneSignal",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "OneSignal"
		},
		{
			"domains": "adthrive.com",
			"disconnectMeName": "Raptive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "slickstream.com",
			"disconnectMeName": "Raptive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "convertkit.com",
			"disconnectMeName": "ConvertKit",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "jwplayer.com",
			"disconnectMeName": "JWPlayer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ccgateway.net",
			"disconnectMeName": "ccgateway.net",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pghub.io",
			"disconnectMeName": "Tapad",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "paypal.com",
			"disconnectMeName": "Paypal",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "248",
			"ghosteryOrganizationName": "eBay",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "yotpo.com",
			"disconnectMeName": "Yotpo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2657",
			"ghosteryOrganizationName": "Yotpo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Yotpo"
		},
		{
			"domains": "paypalobjects.com",
			"ghosteryId": "248",
			"ghosteryOrganizationName": "eBay",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bootstrapcdn.com",
			"ghosteryId": "5320",
			"ghosteryOrganizationName": "BootstrapCDN",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "helpscout.net",
			"disconnectMeName": "HelpScout",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "rakuten.com",
			"disconnectMeName": "Rakuten",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "linksynergy.com",
			"disconnectMeName": "Rakuten",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3334",
			"ghosteryOrganizationName": "Rakuten Marketing LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Rakuten"
		},
		{
			"domains": "imgix.net",
			"disconnectMeName": "Imgix",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "sardine.ai",
			"disconnectMeName": "SardineAI",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mapixl.com",
			"disconnectMeName": "MarketingArchitects",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "servedbyadbutler.com",
			"disconnectMeName": "Sparklit",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "userzoom.com",
			"ghosteryId": "1692",
			"ghosteryOrganizationName": "UserZoom",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mparticle.com",
			"disconnectMeName": "mParticle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mouseflow.com",
			"disconnectMeName": "Mouseflow",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "418",
			"ghosteryOrganizationName": "Mouseflow",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Mouseflow"
		},
		{
			"domains": "segment.com",
			"disconnectMeName": "Twilio",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1440",
			"ghosteryOrganizationName": "Segment",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "litix.io",
			"ghosteryId": "4482",
			"ghosteryOrganizationName": "Mux",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "intercom.io",
			"disconnectMeName": "Intercom",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1161",
			"ghosteryOrganizationName": "Intercom",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Intercom"
		},
		{
			"domains": "intercomcdn.com",
			"ghosteryId": "1161",
			"ghosteryOrganizationName": "Intercom",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "gravatar.com",
			"disconnectMeName": "Automattic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "245",
			"ghosteryOrganizationName": "Automattic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Automattic"
		},
		{
			"domains": "googleusercontent.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "scdn.co",
			"ghosteryId": "1816",
			"ghosteryOrganizationName": "Spotify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "vidazoo.com",
			"disconnectMeName": "Vidazoo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pbstck.com",
			"disconnectMeName": "Pubstack",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "klarnaservices.com",
			"disconnectMeName": "Klarna",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "listrakbi.com",
			"disconnectMeName": "Listrak",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1115",
			"ghosteryOrganizationName": "Listrak",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Listrak"
		},
		{
			"domains": "ywxi.net",
			"ghosteryId": "1141",
			"ghosteryOrganizationName": "McAfee",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "listrak.com",
			"disconnectMeName": "Listrak",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "2o7.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "pepperjam.com",
			"disconnectMeName": "Partnerize",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "espssl.com",
			"disconnectMeName": "Listrak",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "rezync.com",
			"disconnectMeName": "ZetaGlobal",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "rfihub.net",
			"disconnectMeName": "ZetaGlobal",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "boomtrain.com",
			"disconnectMeName": "ZetaGlobal",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "rfihub.com",
			"disconnectMeName": "ZetaGlobal",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ziffstatic.com",
			"ghosteryId": "660",
			"ghosteryOrganizationName": "Ziff Davis LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "app-us1.com",
			"disconnectMeName": "ActiveCampaign",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "zdbb.net",
			"ghosteryId": "660",
			"ghosteryOrganizationName": "Ziff Davis LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "trackcmp.net",
			"disconnectMeName": "ActiveCampaign",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5121",
			"ghosteryOrganizationName": "Active Campaign",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ampproject.org",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "digicert.com",
			"ghosteryId": "1526",
			"ghosteryOrganizationName": "Digicert",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "nextdoor.com",
			"disconnectMeName": "Nextdoor",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "samplicio.us",
			"disconnectMeName": "Cint",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "dotmetrics.net",
			"disconnectMeName": "DotMetrics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "videoplayerhub.com",
			"disconnectMeName": "Blockthrough",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cpx.to",
			"disconnectMeName": "Captify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1976",
			"ghosteryOrganizationName": "Captify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Captify"
		},
		{
			"domains": "servebom.com",
			"disconnectMeName": "FuturePlc",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2052",
			"ghosteryOrganizationName": "Purch Group, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sndcdn.com",
			"ghosteryId": "1817",
			"ghosteryOrganizationName": "SoundCloud",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ctfassets.net",
			"ghosteryId": "5325",
			"ghosteryOrganizationName": "Contentful GmbH",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pingdom.net",
			"disconnectMeName": "SolarWinds",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "consentmanager.net",
			"ghosteryId": "1813",
			"ghosteryOrganizationName": "iubenda",
			"whenAddedToGhostery": "2024-07-02T17:16:11.000Z"
		},
		{
			"domains": "mxpnl.com",
			"disconnectMeName": "Mixpanel",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "227",
			"ghosteryOrganizationName": "Mixpanel",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Mixpanel"
		},
		{
			"domains": "quora.com",
			"disconnectMeName": "Quora",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mgid.com",
			"disconnectMeName": "MGID",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "577",
			"ghosteryOrganizationName": "MGID Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "MGID"
		},
		{
			"domains": "mixpanel.com",
			"disconnectMeName": "Mixpanel",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "227",
			"ghosteryOrganizationName": "Mixpanel",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Mixpanel"
		},
		{
			"domains": "clearbit.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5324",
			"ghosteryOrganizationName": "Clearbit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "xing.com",
			"ghosteryId": "2787",
			"ghosteryOrganizationName": "XING",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cquotient.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Salesforce"
		},
		{
			"domains": "pxf.io",
			"disconnectMeName": "Impact",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "igodigital.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Salesforce"
		},
		{
			"domains": "privacy-center.org",
			"disconnectMeName": "Didomi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5327",
			"ghosteryOrganizationName": "Didomi",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Didomi"
		},
		{
			"domains": "pro-market.net",
			"disconnectMeName": "Datonics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "12",
			"ghosteryOrganizationName": "AlmondNet",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "shopify.com",
			"ghosteryId": "2179",
			"ghosteryOrganizationName": "Shopify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "shopifysvc.com",
			"disconnectMeName": "Shopify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "scarabresearch.com",
			"disconnectMeName": "SAP",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5182",
			"ghosteryOrganizationName": "Emarsys",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cookiebot.com",
			"disconnectMeName": "UserCentrics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "getsmartcontent.com",
			"ghosteryId": "2133",
			"ghosteryOrganizationName": "Get Smart Content",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "quantcast.com",
			"disconnectMeName": "Quantcast",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Quantcast"
		},
		{
			"domains": "inmobi.com",
			"disconnectMeName": "InMobi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "bluecore.com",
			"disconnectMeName": "Bluecore",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3058",
			"ghosteryOrganizationName": "TriggerMail",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "inside-graph.com",
			"ghosteryId": "3042",
			"ghosteryOrganizationName": "PowerFront",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pangle-ads.com",
			"disconnectMeName": "Bytedance",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pubnation.com",
			"disconnectMeName": "OpenX",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "aweber.com",
			"disconnectMeName": "AWeber",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1305",
			"ghosteryOrganizationName": "AWeber Communications",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "AWeber"
		},
		{
			"domains": "mediavine.com",
			"disconnectMeName": "Mediavine",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "sda.fyi",
			"disconnectMeName": "sda.fyi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pendo.io",
			"disconnectMeName": "Pendo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "airpr.com",
			"disconnectMeName": "Onclusive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5235",
			"ghosteryOrganizationName": "AirPR",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "marketo.com",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "steelhousemedia.com",
			"disconnectMeName": "MNTN",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "751",
			"ghosteryOrganizationName": "Steel House, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "optmstr.com",
			"ghosteryId": "5129",
			"ghosteryOrganizationName": "OptinMonster",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ensighten.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "728",
			"ghosteryOrganizationName": "Ensighten",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "rudderlabs.com",
			"disconnectMeName": "RudderStack",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "myfonts.net",
			"disconnectMeName": "MyFonts",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2683",
			"ghosteryOrganizationName": "MyFonts",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "MyFonts"
		},
		{
			"domains": "useinsider.com",
			"ghosteryId": "4816",
			"ghosteryOrganizationName": "Insider",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "audioeye.com",
			"disconnectMeName": "AudioEye",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "iadvize.com",
			"ghosteryId": "2128",
			"ghosteryOrganizationName": "iAdvize",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "decibelinsight.net",
			"ghosteryId": "3679",
			"ghosteryOrganizationName": "Medallia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "kaltura.com",
			"disconnectMeName": "Kaltura",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1480",
			"ghosteryOrganizationName": "Kaltura",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Kaltura"
		},
		{
			"domains": "blogherads.com",
			"disconnectMeName": "BlogHer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "29",
			"ghosteryOrganizationName": "Penske Media Corporation",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tinypass.com",
			"disconnectMeName": "Piano",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Piano"
		},
		{
			"domains": "piano.io",
			"disconnectMeName": "Piano",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Piano"
		},
		{
			"domains": "browsiprod.com",
			"disconnectMeName": "Browsi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "treasuredata.com",
			"disconnectMeName": "TreasureData",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4464",
			"ghosteryOrganizationName": "arm",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "jwplatform.com",
			"disconnectMeName": "JWPlayer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "lightboxcdn.com",
			"disconnectMeName": "Digioh",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "aidemsrv.com",
			"disconnectMeName": "aidem",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "e-volution.ai",
			"disconnectMeName": "EvolutionTechnologies",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "adscale.de",
			"disconnectMeName": "adscale",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "342",
			"ghosteryOrganizationName": "Ströer SSP GmbH",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "lunamedia.live",
			"disconnectMeName": "LunaMedia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cloudinary.com",
			"disconnectMeName": "Cloudinary",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pub.network",
			"disconnectMeName": "Freestar",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "scaredsnakes.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "segment.io",
			"disconnectMeName": "Twilio",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1440",
			"ghosteryOrganizationName": "Segment",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "redd.it",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "redditmedia.com",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "smadex.com",
			"disconnectMeName": "Entravision",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "everestjs.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "brightcove.net",
			"ghosteryId": "683",
			"ghosteryOrganizationName": "Brightcove",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bkrtx.com",
			"disconnectMeName": "Oracle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Oracle"
		},
		{
			"domains": "granify.com",
			"ghosteryId": "2980",
			"ghosteryOrganizationName": "Granify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "foresee.com",
			"ghosteryId": "330",
			"ghosteryOrganizationName": "ForeSee Results",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "t13.io",
			"disconnectMeName": "t13.io",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "zencdn.net",
			"disconnectMeName": "Brightcove",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4475",
			"ghosteryOrganizationName": "Zencoder",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tappx.com",
			"disconnectMeName": "tappx",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "vox-cdn.com",
			"ghosteryId": "3999",
			"ghosteryOrganizationName": "Vox Media",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "betweendigital.com",
			"disconnectMeName": "BetweenDigital",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2492",
			"ghosteryOrganizationName": "Between Digital",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fonts.net",
			"ghosteryId": "3427",
			"ghosteryOrganizationName": "Monotype Imaging",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "btstatic.com",
			"disconnectMeName": "TransUnion",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "761",
			"ghosteryOrganizationName": "Signal Digital Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "convertexperiments.com",
			"disconnectMeName": "convertexperiments.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5041",
			"ghosteryOrganizationName": "Convert",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Convert"
		},
		{
			"domains": "recaptcha.net",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2024-01-23T11:41:01.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "samba.tv",
			"disconnectMeName": "Samba.tv",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5388",
			"ghosteryOrganizationName": "Samba TV",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mookie1.com",
			"disconnectMeName": "WPP",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4758",
			"ghosteryOrganizationName": "Xaxis",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "jwpsrv.com",
			"disconnectMeName": "JWPlayer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adnami.io",
			"disconnectMeName": "Adnami",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "jwpcdn.com",
			"disconnectMeName": "JWPlayer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "jwpltx.com",
			"disconnectMeName": "JWPlayer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wpengine.com",
			"ghosteryId": "5415",
			"ghosteryOrganizationName": "WP Engine",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cheqzone.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "adpushup.com",
			"disconnectMeName": "Zelto",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "datadoghq.com",
			"disconnectMeName": "DataDog",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "4dex.io",
			"disconnectMeName": "Adagio",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cpmstar.com",
			"disconnectMeName": "CPMStar",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "647",
			"ghosteryOrganizationName": "CPMStar",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "CPMStar"
		},
		{
			"domains": "smartyads.com",
			"disconnectMeName": "SmartyAds",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "krxd.net",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Salesforce"
		},
		{
			"domains": "survicate.com",
			"disconnectMeName": "Survicate",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "swiftypecdn.com",
			"ghosteryId": "5332",
			"ghosteryOrganizationName": "Elastic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "auth0.com",
			"ghosteryId": "5313",
			"ghosteryOrganizationName": "Auth0 Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "office.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "dstillery.com",
			"disconnectMeName": "Dstillery",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "nyt.com",
			"ghosteryId": "1962",
			"ghosteryOrganizationName": "The New York Times Company",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "zqtk.net",
			"ghosteryId": "246",
			"ghosteryOrganizationName": "comScore, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adrecover.com",
			"ghosteryId": "3507",
			"ghosteryOrganizationName": "AdPushUp, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "outbrainimg.com",
			"disconnectMeName": "Outbrain",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Outbrain"
		},
		{
			"domains": "revjet.com",
			"disconnectMeName": "Innervate",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "dyntrk.com",
			"disconnectMeName": "DynAdmic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "matheranalytics.com",
			"disconnectMeName": "MatherEconomics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5233",
			"ghosteryOrganizationName": "Mather Economics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "digitaleast.mobi",
			"disconnectMeName": "DigitalEast",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "digitalgov.gov",
			"ghosteryId": "5409",
			"ghosteryOrganizationName": "USA Government",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "presage.io",
			"disconnectMeName": "Ogury",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "infolinks.com",
			"disconnectMeName": "Infolinks",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "88",
			"ghosteryOrganizationName": "Infolinks",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Infolinks"
		},
		{
			"domains": "sekindo.com",
			"disconnectMeName": "Primis",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2061",
			"ghosteryOrganizationName": "SekiNdo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "npttech.com",
			"disconnectMeName": "Piano",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Piano"
		},
		{
			"domains": "a-mx.com",
			"disconnectMeName": "AdaptMX",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "aticdn.net",
			"ghosteryId": "1270",
			"ghosteryOrganizationName": "AT Internet",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tvpixel.com",
			"disconnectMeName": "LiveRamp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp",
			"whenAddedToGhostery": "2024-05-22T14:55:07.000Z",
			"organizationKnownAs": "LiveRamp"
		},
		{
			"domains": "revcontent.com",
			"disconnectMeName": "RevContent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3626",
			"ghosteryOrganizationName": "Revcontent",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Revcontent"
		},
		{
			"domains": "ad-score.com",
			"disconnectMeName": "Protected Media",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "earnify.com",
			"disconnectMeName": "Earnify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4358",
			"ghosteryOrganizationName": "Earnify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Earnify"
		},
		{
			"domains": "a2z.com",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "fwmrm.net",
			"disconnectMeName": "Comcast",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Comcast"
		},
		{
			"domains": "admantx.com",
			"ghosteryId": "5336",
			"ghosteryOrganizationName": "Expert System, SpA",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "nondescriptnote.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "polarcdn.com",
			"disconnectMeName": "Nova",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "polarcdn-engine.com",
			"disconnectMeName": "Nova",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "klevu.com",
			"disconnectMeName": "Klevu",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "stamped.io",
			"disconnectMeName": "Stamped",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "klaviyo.com",
			"disconnectMeName": "Klaviyo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "merchant-center-analytics.goog",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "im-apps.net",
			"disconnectMeName": "IntimateMerger",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4067",
			"ghosteryOrganizationName": "Intimate Merger",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "snackly.co",
			"ghosteryId": "4282",
			"ghosteryOrganizationName": "Minute.ly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "conviva.com",
			"disconnectMeName": "Conviva",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Conviva"
		},
		{
			"domains": "friendbuy.com",
			"ghosteryId": "5219",
			"ghosteryOrganizationName": "FriendBuy",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "s-microsoft.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ib-ibi.com",
			"disconnectMeName": "iBehavior",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "611",
			"ghosteryOrganizationName": "KBM Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "deepintent.com",
			"disconnectMeName": "Deep Intent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5037",
			"ghosteryOrganizationName": "Deep Intent",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Deep Intent"
		},
		{
			"domains": "stickyadstv.com",
			"disconnectMeName": "Comcast",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Comcast"
		},
		{
			"domains": "farsnails.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ngtv.io",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "jivox.com",
			"disconnectMeName": "Jivox",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1872",
			"ghosteryOrganizationName": "Jivox",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Jivox"
		},
		{
			"domains": "line-scdn.net",
			"disconnectMeName": "LYCorp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5232",
			"ghosteryOrganizationName": "Line",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "naver.net",
			"ghosteryId": "4249",
			"ghosteryOrganizationName": "Naver",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "line.me",
			"disconnectMeName": "LYCorp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5232",
			"ghosteryOrganizationName": "Line",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pstatic.net",
			"ghosteryId": "4249",
			"ghosteryOrganizationName": "Naver",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "naver.com",
			"ghosteryId": "4249",
			"ghosteryOrganizationName": "Naver",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tradedoubler.com",
			"disconnectMeName": "Tradedoubler",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "668",
			"ghosteryOrganizationName": "Tradedoubler AB",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Tradedoubler"
		},
		{
			"domains": "dailymotion.com",
			"ghosteryId": "5411",
			"ghosteryOrganizationName": "Vivendi",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "dm-event.net",
			"ghosteryId": "5411",
			"ghosteryOrganizationName": "Vivendi",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "singular.net",
			"disconnectMeName": "SingularLabs",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "yahoo.net",
			"disconnectMeName": "Yahoo!",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pubwise.io",
			"disconnectMeName": "PubWise",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "shop.app",
			"disconnectMeName": "Shopify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "rebuyengine.com",
			"disconnectMeName": "RebuyInc",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "smile.io",
			"disconnectMeName": "Smile",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "trustpilot.com",
			"disconnectMeName": "TrustPilot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5155",
			"ghosteryOrganizationName": "Trustpilot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Trustpilot"
		},
		{
			"domains": "strangeclocks.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "apple.com",
			"ghosteryId": "390",
			"ghosteryOrganizationName": "Apple",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "esm1.net",
			"disconnectMeName": "CoxEnterprises",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4642",
			"ghosteryOrganizationName": "Dealer.com",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "travelaudience.com",
			"disconnectMeName": "Amadeus",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4913",
			"ghosteryOrganizationName": "Travel Audience",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wishabi.net",
			"disconnectMeName": "Wishabi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "curalate.com",
			"disconnectMeName": "Bazaarvoice",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "brcdn.com",
			"ghosteryId": "396",
			"ghosteryOrganizationName": "BloomReach",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wishabi.com",
			"disconnectMeName": "Wishabi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "brsrvr.com",
			"disconnectMeName": "BloomReach",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "396",
			"ghosteryOrganizationName": "BloomReach",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "BloomReach"
		},
		{
			"domains": "qualaroo.com",
			"disconnectMeName": "Qualaroo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tp88trk.com",
			"disconnectMeName": "tp88trk",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mailchimp.com",
			"disconnectMeName": "MailChimp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1187",
			"ghosteryOrganizationName": "MailChimp",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "MailChimp"
		},
		{
			"domains": "addtoany.com",
			"disconnectMeName": "AddtoAny",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4",
			"ghosteryOrganizationName": "AddToAny",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "AddToAny"
		},
		{
			"domains": "cdninstagram.com",
			"disconnectMeName": "Meta",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Meta"
		},
		{
			"domains": "sascdn.com",
			"disconnectMeName": "Equativ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "stretchsquirrel.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "amazon.com",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Amazon"
		},
		{
			"domains": "ssl-images-amazon.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "resetdigital.co",
			"disconnectMeName": "ResetDigital",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "eyeota.net",
			"disconnectMeName": "Eyeota",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1727",
			"ghosteryOrganizationName": "Eyeota",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Eyeota"
		},
		{
			"domains": "exelator.com",
			"disconnectMeName": "Nielsen",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Nielsen"
		},
		{
			"domains": "rmtag.com",
			"disconnectMeName": "Rakuten",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3334",
			"ghosteryOrganizationName": "Rakuten Marketing LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Rakuten"
		},
		{
			"domains": "bing.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "dynamicyield.com",
			"ghosteryId": "2280",
			"ghosteryOrganizationName": "Dynamic Yield",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "affec.tv",
			"disconnectMeName": "HybridTheory",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "payments-amazon.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "espncdn.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "githubassets.com",
			"ghosteryId": "1618",
			"ghosteryOrganizationName": "GitHub, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bfmio.com",
			"disconnectMeName": "BeachFront",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "selectmedia.asia",
			"disconnectMeName": "SelectMedia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "salesforce.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Salesforce"
		},
		{
			"domains": "salesforceliveagent.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Salesforce"
		},
		{
			"domains": "res-x.com",
			"disconnectMeName": "Monetate",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "351",
			"ghosteryOrganizationName": "Certona",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "nocookie.net",
			"ghosteryId": "5412",
			"ghosteryOrganizationName": "Wikia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wikia-services.com",
			"ghosteryId": "5412",
			"ghosteryOrganizationName": "Wikia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "basis.net",
			"disconnectMeName": "BasisTechnologies",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "impactradius-tag.com",
			"ghosteryId": "2230",
			"ghosteryOrganizationName": "Impact Radius",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "afterpay.com",
			"disconnectMeName": "AfterPay",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mediawallahscript.com",
			"disconnectMeName": "Mediawallah",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "h-cdn.com",
			"ghosteryId": "4896",
			"ghosteryOrganizationName": "Hola CDN",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "appnexus.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "knotch.it",
			"ghosteryId": "4114",
			"ghosteryOrganizationName": "Knotch",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "brightcove.com",
			"disconnectMeName": "Brightcove",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "683",
			"ghosteryOrganizationName": "Brightcove",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Brightcove"
		},
		{
			"domains": "usemessages.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "mfadsrvr.com",
			"disconnectMeName": "MediaForce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "intergient.com",
			"disconnectMeName": "Playwire",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "intergi.com",
			"disconnectMeName": "Intergi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "playwire.com",
			"disconnectMeName": "Playwire",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4577",
			"ghosteryOrganizationName": "Snowplow",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fbcdn.net",
			"disconnectMeName": "Meta",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Meta"
		},
		{
			"domains": "s-onetag.com",
			"disconnectMeName": "Sovrn",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5424",
			"ghosteryOrganizationName": "OneTag",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "etsystatic.com",
			"ghosteryId": "2030",
			"ghosteryOrganizationName": "Etsy, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wsod.com",
			"disconnectMeName": "Markit",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "624",
			"ghosteryOrganizationName": "Markit on Demand",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Markit"
		},
		{
			"domains": "raygun.io",
			"ghosteryId": "4101",
			"ghosteryOrganizationName": "Raygun",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adobe.com",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "yottaa.net",
			"ghosteryId": "5419",
			"ghosteryOrganizationName": "Yottaa",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "kickfire.com",
			"disconnectMeName": "IDG",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ebaystatic.com",
			"disconnectMeName": "eBay",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "220",
			"ghosteryOrganizationName": "eBay",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "eBay"
		},
		{
			"domains": "ebayimg.com",
			"disconnectMeName": "eBay",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "220",
			"ghosteryOrganizationName": "eBay",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "eBay"
		},
		{
			"domains": "ebayrtm.com",
			"ghosteryId": "220",
			"ghosteryOrganizationName": "eBay",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ebayadservices.com",
			"disconnectMeName": "eBay",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "perfdrive.com",
			"disconnectMeName": "Radware",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "nitropay.com",
			"disconnectMeName": "NitroPay",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5346",
			"ghosteryOrganizationName": "GG Software LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "kameleoon.eu",
			"disconnectMeName": "Kameleoon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3044",
			"ghosteryOrganizationName": "Kameleoon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Kameleoon"
		},
		{
			"domains": "gorgias.chat",
			"disconnectMeName": "Gorgias",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "chimpstatic.com",
			"disconnectMeName": "MailChimp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1187",
			"ghosteryOrganizationName": "MailChimp",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "MailChimp"
		},
		{
			"domains": "shopifycdn.com",
			"ghosteryId": "2179",
			"ghosteryOrganizationName": "Shopify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "parastorage.com",
			"ghosteryId": "5414",
			"ghosteryOrganizationName": "Wix",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wixmp.com",
			"ghosteryId": "5414",
			"ghosteryOrganizationName": "Wix",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wix.com",
			"ghosteryId": "5414",
			"ghosteryOrganizationName": "Wix",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sumo.com",
			"disconnectMeName": "BDOW",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3560",
			"ghosteryOrganizationName": "SumoMe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "callrail.com",
			"disconnectMeName": "CallRail",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2652",
			"ghosteryOrganizationName": "CallRail",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "CallRail"
		},
		{
			"domains": "sumome.com",
			"disconnectMeName": "BDOW",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3560",
			"ghosteryOrganizationName": "SumoMe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "aniview.com",
			"disconnectMeName": "Aniview",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "upsellit.com",
			"disconnectMeName": "UpsellIt",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "642",
			"ghosteryOrganizationName": "UpSellit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "UpSellit"
		},
		{
			"domains": "sundaysky.com",
			"disconnectMeName": "SundaySky",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1896",
			"ghosteryOrganizationName": "SundaySky",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "SundaySky"
		},
		{
			"domains": "rightnowtech.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "shopifyapps.com",
			"disconnectMeName": "Shopify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "refersion.com",
			"disconnectMeName": "Refersion",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3359",
			"ghosteryOrganizationName": "Refersion",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Refersion"
		},
		{
			"domains": "jsrdn.com",
			"disconnectMeName": "DistroScale",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4472",
			"ghosteryOrganizationName": "Distroscale",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Distroscale"
		},
		{
			"domains": "turner.com",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mrtnsvr.com",
			"disconnectMeName": "mrtnsvr.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "warnermedia.com",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "modularmental.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "wistia.net",
			"ghosteryId": "1307",
			"ghosteryOrganizationName": "Wistia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "dynamics.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "acuityplatform.com",
			"disconnectMeName": "Acuity",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1635",
			"ghosteryOrganizationName": "Acuity Ads",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Acuity"
		},
		{
			"domains": "msecnd.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "nowinteract.com",
			"ghosteryId": "3623",
			"ghosteryOrganizationName": "Now Interact",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "connectad.io",
			"disconnectMeName": "ConnectAdRealtime",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cedexis.com",
			"disconnectMeName": "Cedexis",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "691",
			"ghosteryOrganizationName": "Cedexis",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Cedexis"
		},
		{
			"domains": "cedexis-radar.net",
			"ghosteryId": "691",
			"ghosteryOrganizationName": "Cedexis",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "browser-update.org",
			"disconnectMeName": "Browser-Update.org",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1146",
			"ghosteryOrganizationName": "Browser-Update",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Browser-Update"
		},
		{
			"domains": "adlooxtracking.com",
			"disconnectMeName": "Adloox",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1455",
			"ghosteryOrganizationName": "Adloox",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adloox"
		},
		{
			"domains": "zeotap.com",
			"disconnectMeName": "Zeotap",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "jetpackdigital.com",
			"ghosteryId": "1859",
			"ghosteryOrganizationName": "Jetpack Digital",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "grow.me",
			"disconnectMeName": "Mediavine",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "plausible.io",
			"ghosteryId": "5437",
			"ghosteryOrganizationName": "Plausible Insights OÜ",
			"whenAddedToGhostery": "2023-10-23T10:26:24.000Z"
		},
		{
			"domains": "instagram.com",
			"disconnectMeName": "Meta",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Meta"
		},
		{
			"domains": "4dsply.com",
			"disconnectMeName": "Adsupply",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2159",
			"ghosteryOrganizationName": "AdSupply",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "AdSupply"
		},
		{
			"domains": "wt-safetag.com",
			"ghosteryId": "335",
			"ghosteryOrganizationName": "Webtrekk",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "msn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "virtualearth.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pixel.ad",
			"disconnectMeName": "pixel.ad",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "714",
			"ghosteryOrganizationName": "Centro",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "getrockerbox.com",
			"disconnectMeName": "RockerBox",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3705",
			"ghosteryOrganizationName": "Rockerbox",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Rockerbox"
		},
		{
			"domains": "salecycle.com",
			"ghosteryId": "1963",
			"ghosteryOrganizationName": "SaleCycle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "edigitalsurvey.com",
			"ghosteryId": "4605",
			"ghosteryOrganizationName": "MaruEdr",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "certona.net",
			"ghosteryId": "351",
			"ghosteryOrganizationName": "Certona",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "yieldify.com",
			"disconnectMeName": "Yieldify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2874",
			"ghosteryOrganizationName": "Yieldify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Yieldify"
		},
		{
			"domains": "petametrics.com",
			"ghosteryId": "5356",
			"ghosteryOrganizationName": "LiftIgniter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "prmutv.co",
			"disconnectMeName": "Permutive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "shopperapproved.com",
			"ghosteryId": "3981",
			"ghosteryOrganizationName": "Shopper Approved",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "acxiom.com",
			"disconnectMeName": "Acxiom",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "alicdn.com",
			"ghosteryId": "3001",
			"ghosteryOrganizationName": "Alibaba",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mmstat.com",
			"ghosteryId": "2149",
			"ghosteryOrganizationName": "MarkMonitor",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "alibaba.com",
			"ghosteryId": "3001",
			"ghosteryOrganizationName": "Alibaba",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mentorsticks.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "adrta.com",
			"ghosteryId": "4097",
			"ghosteryOrganizationName": "Pixalate, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "advertising.com",
			"disconnectMeName": "Yahoo!",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "addthis.com",
			"disconnectMeName": "Oracle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Oracle"
		},
		{
			"domains": "azurefd.net",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "b0e8.com",
			"disconnectMeName": "BrightEdge",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "brightedge.com",
			"disconnectMeName": "BrightEdge",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "vindicosuite.com",
			"disconnectMeName": "Viant",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "739",
			"ghosteryOrganizationName": "Vindico Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "webtrendslive.com",
			"disconnectMeName": "Webtrends",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "181",
			"ghosteryOrganizationName": "Webtrends",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Webtrends"
		},
		{
			"domains": "optimahub.com",
			"ghosteryId": "3231",
			"ghosteryOrganizationName": "Datalicious",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tiktokcdn.com",
			"ghosteryId": "5432",
			"ghosteryOrganizationName": "ByteDance Inc",
			"whenAddedToGhostery": "2023-09-27T14:48:32.000Z"
		},
		{
			"domains": "cohesionapps.com",
			"ghosteryId": "5118",
			"ghosteryOrganizationName": "Red Ventures",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "events.launchdarkly.com",
			"ghosteryId": "4946",
			"ghosteryOrganizationName": "Launch Darkly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pricespider.com",
			"ghosteryId": "4411",
			"ghosteryOrganizationName": "Price Spider",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "snippet.minute.ly",
			"ghosteryId": "4282",
			"ghosteryOrganizationName": "Minute.ly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sanalytics.disneyplus.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company",
			"whenAddedToGhostery": "2024-05-28T13:05:38.000Z"
		},
		{
			"domains": "widget.engageya.com",
			"ghosteryId": "4404",
			"ghosteryOrganizationName": "Engageya",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "static.ordergroove.com",
			"ghosteryId": "4456",
			"ghosteryOrganizationName": "Order Groove",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "app.viral-loops.com",
			"ghosteryId": "4339",
			"ghosteryOrganizationName": "Viral-Loops",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tracker.unbxdapi.com",
			"ghosteryId": "4437",
			"ghosteryOrganizationName": "UNBXD",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		}
	]
};
